import { useState, useEffect } from 'react';
import s from './Header.module.css';

interface Props {
  onTrialClick?: () => void;
}

const NAV_ITEMS = [
  { label: '機能', href: '#features' },
  { label: '料金', href: '#pricing' },

  { label: 'FAQ', href: '#faq' },
  { label: 'お問い合わせ', href: '#contact' },
];

export function Header({ onTrialClick }: Props) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMobile = () => setMobileOpen(false);

  return (
    <header className={`${s.header} ${scrolled ? s.scrolled : ''}`}>
      <div className={s.inner}>
        <a href="#" className={s.logo}>
          <span className={s.logoBadge}>ME</span>
          <span className={s.logoText}>住縁 Mirai EMS</span>
        </a>

        <nav className={s.nav}>
          {NAV_ITEMS.map((item) => (
            <a key={item.href} href={item.href} className={s.navLink}>
              {item.label}
            </a>
          ))}
          <button className={s.cta} onClick={onTrialClick}>
            無料トライアル
          </button>
        </nav>

        <button className={s.hamburger} onClick={() => setMobileOpen(true)} aria-label="メニュー">
          ☰
        </button>
      </div>

      <div className={`${s.mobileMenu} ${mobileOpen ? s.open : ''}`}>
        <button className={s.closeBtn} onClick={closeMobile} aria-label="閉じる">✕</button>
        {NAV_ITEMS.map((item) => (
          <a key={item.href} href={item.href} className={s.mobileLink} onClick={closeMobile}>
            {item.label}
          </a>
        ))}
        <button className={s.mobileCta} onClick={() => { closeMobile(); onTrialClick(); }}>
          無料トライアル
        </button>
      </div>
    </header>
  );
}
